var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPythonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61_83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 90,
    height: 90,
    rx: 20,
    fill: "url(#paint0_linear_61_83)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.44 66.7256C52.44 67.9817 53.4608 69 54.72 69C55.9792 69 57 67.9817 57 66.7256C57 65.4694 55.9792 64.4511 54.72 64.4511C53.4608 64.4511 52.44 65.4694 52.44 66.7256ZM41 22.2744C41 23.5306 42.0208 24.5489 43.28 24.5489C44.5392 24.5489 45.56 23.5306 45.56 22.2744C45.56 21.0183 44.5392 20 43.28 20C42.0208 20 41 21.0183 41 22.2744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_61_83)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0833 27.625H67.75V20.125C67.75 16.195 64.2 13 59.8334 13H38.1666C33.8 13 30.25 16.195 30.25 20.125V27.625H21.9166C17.55 27.625 14 30.82 14 34.75V54.25C14 58.18 17.55 61.375 21.9166 61.375H30.25V68.875C30.25 72.805 33.8 76 38.1666 76H59.8334C64.2 76 67.75 72.805 67.75 68.875V61.375H76.0833C80.45 61.375 84 58.18 84 54.25V34.75C84 30.82 80.45 27.625 76.0833 27.625ZM21.9166 56.875C20.3084 56.875 19 55.6975 19 54.25V34.75C19 33.3025 20.3083 32.125 21.9166 32.125H46.2917C47.6751 32.125 48.7917 31.12 48.7917 29.875C48.7917 28.6301 47.675 27.625 46.2917 27.625H35.2501V20.125C35.2501 18.6776 36.5584 17.5 38.1666 17.5H59.8334C61.4416 17.5 62.75 18.6775 62.75 20.125V40.3225C62.75 41.3875 61.7916 42.25 60.6084 42.25H37.3916C33.45 42.25 30.25 45.1375 30.25 48.6775V56.875H21.9166ZM79 54.25C79 55.6975 77.6917 56.875 76.0833 56.875H51.7083C50.3249 56.875 49.2083 57.88 49.2083 59.125C49.2083 60.3699 50.325 61.375 51.7083 61.375H62.7499V68.875C62.7499 70.3224 61.4416 71.5 59.8334 71.5H38.1666C36.5584 71.5 35.25 70.3225 35.25 68.875V48.6775C35.25 47.6125 36.2084 46.75 37.3916 46.75H60.6084C64.55 46.75 67.75 43.8625 67.75 40.3225V32.125H76.0833C77.6916 32.125 79 33.3025 79 34.75V54.25Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61_83",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_61_83",
    x: 10,
    y: 13,
    width: 78,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_83",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#925EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python_icon.cfdbbaca1d2135fe4ac72ccb096d5de4.svg";
export { ForwardRef as ReactComponent };